import dayjs from 'dayjs'
import { getLocaleDateFormat } from '@/util/dateFormat'

export function desensitizationString(str = '', first = 1, last = 1) {
  try {
    if (!str) {
      return ''
    }
    const l = str.length
    if (l > (first + last)) {
      const left = l - (first + last)
      return str.slice(0, first) + ((Array.from({ length: left })).map(v => '*')).join('') + str.slice(l - last, l)
    } else {
      return str.charAt(0) + '*'
    }
  } catch (error) {
    console.error('被捕获:' + error)
    return str
  }
}

export function formatTime(time, formatStr = 'YYYY-MM-DD') {
  if (!time) return '-'
  const t = dayjs(time)
  if (t.isValid()) {
    return t.format(getLocaleDateFormat(formatStr))
  } else {
    return time
  }
}

export function readableWeek(time) {
  const weekdays = dayjs.weekdays()
  const unknown = '-'

  if (!time) return unknown
  
  const t = dayjs(time)

  const weekdayI = t.day()
  const rst = weekdays[weekdayI]
  if (!rst) {
    console.error(`[filter/readableWeek]无法获得当前的weekday`)
    return unknown
  }
  return rst
}

export function useThisInsteadIfEmpty(str = '', instead = '-') {
  if (!str) return instead
  return str
}
